import React, { useContext, useEffect, useState } from "react";
import { TaskEditorEventService } from "../../services/event-service";
import "./TaskEditorPreview.css";
import LocalStorageService from "../../services/localstorage-service";
import TaskEditor2 from "./TaskEditor2";
import { AppContext, NavState } from "../App";
import { createPortal } from "react-dom";

export enum TaskEditorEvent {
    ENABLE_PREVIEW = "ENABLE_PREVIEW"
}

export default function TaskEditorPreview() {
    const [hidden, setHidden] = useState(!LocalStorageService.getSidenavSettings().showGraph);
    const [showPreview, setShowPreview] = useState(false);
    const [lock, setLock] = useState(false);
    const [scrollPosition, setScrollPosition] = useState({ x: 0, y: 0 });
    const { navState } = useContext(AppContext);

    useEffect(() => {
        TaskEditorEventService.on(TaskEditorEvent.ENABLE_PREVIEW, (enable: boolean) => setHidden(!enable));
    }, [])

    const setScroll = (event:any) => {
        if (!lock) {
            const graphContainer = document.getElementById('graph-container');
            if (!graphContainer) return;
    
            const rect = graphContainer.getBoundingClientRect();
            const mouseX = event.clientX - rect.left;
            const mouseY = event.clientY - rect.top;
          
            const padding = 100;
            const relativeX = (mouseX - padding) / (rect.width - 2 *  padding);
            const relativeY = (mouseY - padding) / (rect.height - 2 * padding);
          
            let scrollX = Math.min(Math.max(relativeX, 0), 1) * (graphContainer.scrollWidth - graphContainer.clientWidth);
            let scrollY = Math.min(Math.max(relativeY, 0), 1) * (graphContainer.scrollHeight - graphContainer.clientHeight);
          
            graphContainer.scrollLeft = scrollX;
            graphContainer.scrollTop = scrollY;

            setScrollPosition({x: scrollX, y: scrollY});
        }
    }

    const openPreview = () => {
        setShowPreview(true);
        setTimeout(() => {
            const graphContainer = document.getElementById('graph-container');
            if (!graphContainer) return;
            graphContainer.scrollLeft = scrollPosition.x;
            graphContainer.scrollTop = scrollPosition.y;
        }, 1);
    }

    if (hidden || navState === NavState.TASK) return null;
    return ( 
        <div onMouseEnter={() => openPreview()} className="showGraph rounded-5">
            <i className={`fas fa-eye`}/>
            <span>Task Editor Preview</span>

            {showPreview && createPortal(<div onMouseLeave={() => setShowPreview(false)} className="graphPreview">
                <div onClick={() => setLock(!lock)} onMouseMove={e => setScroll(e)} id="taskEditorOverlay">
                    <i className={`fas ${lock ? "fa-lock" : "fa-unlock"}`}/>
                </div>
                <TaskEditor2 hideMenu={true}/>
            </div>,
            document.body)}
        </div>
    )
}
